
export default {
    name: 'Single',
    props: {
        value: {
            type: [String, Number, Boolean],
            default: null
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        modelValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        handleSelect(value) {
            this.modelValue = value
        }
    }
}
